// extracted by mini-css-extract-plugin
export default {"margin":"Dialogs_margin__GYLif","headerValues":"Dialogs_headerValues__hsZQI","headerLabels":"Dialogs_headerLabels__MgAS7"};